import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCreditCard, FiLock, FiCheckCircle, FiAlertCircle } = FiIcons;

const MockStripePayment = ({ amount, onSuccess, onError }) => {
  const [processing, setProcessing] = useState(false);
  const [cardData, setCardData] = useState({
    number: '',
    expiry: '',
    cvc: '',
    name: ''
  });

  const formatCardNumber = (value) => {
    const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    const matches = v.match(/\d{4,16}/g);
    const match = matches && matches[0] || '';
    const parts = [];
    for (let i = 0, len = match.length; i < len; i += 4) {
      parts.push(match.substring(i, i + 4));
    }
    if (parts.length) {
      return parts.join(' ');
    } else {
      return value;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'number') {
      setCardData(prev => ({ ...prev, [name]: formatCardNumber(value) }));
    } else {
      setCardData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    // Simulate network request to Stripe
    setTimeout(() => {
      // Simple validation mock
      if (cardData.number.length < 16) {
        setProcessing(false);
        if (onError) onError('Invalid card number');
      } else {
        setProcessing(false);
        if (onSuccess) onSuccess();
      }
    }, 2000);
  };

  return (
    <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center">
          <SafeIcon icon={FiCreditCard} className="mr-2 h-5 w-5 text-blue-600" />
          Payment Details
        </h3>
        <div className="flex gap-2">
          <div className="h-6 w-10 bg-gray-100 rounded flex items-center justify-center text-xs font-bold text-gray-500">VISA</div>
          <div className="h-6 w-10 bg-gray-100 rounded flex items-center justify-center text-xs font-bold text-gray-500">MC</div>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Card Information</label>
          <div className="relative">
            <input
              type="text"
              name="number"
              placeholder="0000 0000 0000 0000"
              maxLength="19"
              value={cardData.number}
              onChange={handleChange}
              className="w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 text-sm transition-all"
              required
            />
            <SafeIcon icon={FiCreditCard} className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Expiry Date</label>
            <input
              type="text"
              name="expiry"
              placeholder="MM / YY"
              maxLength="5"
              value={cardData.expiry}
              onChange={handleChange}
              className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 text-sm transition-all"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">CVC</label>
            <div className="relative">
              <input
                type="text"
                name="cvc"
                placeholder="123"
                maxLength="4"
                value={cardData.cvc}
                onChange={handleChange}
                className="w-full pl-3 pr-8 py-2.5 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 text-sm transition-all"
                required
              />
              <SafeIcon icon={FiLock} className="absolute right-3 top-3 h-4 w-4 text-gray-400" />
            </div>
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Cardholder Name</label>
          <input
            type="text"
            name="name"
            placeholder="John Doe"
            value={cardData.name}
            onChange={handleChange}
            className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 text-sm transition-all"
            required
          />
        </div>

        <div className="pt-4">
          <button
            type="submit"
            disabled={processing}
            className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white py-3 rounded-lg font-bold text-sm transition-all flex items-center justify-center shadow-md hover:shadow-lg"
          >
            {processing ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mr-2"></div>
                Processing...
              </>
            ) : (
              <>
                Pay €{amount}
                <SafeIcon icon={FiLock} className="ml-2 h-4 w-4" />
              </>
            )}
          </button>
          <div className="mt-3 text-center flex items-center justify-center text-xs text-gray-500">
            <SafeIcon icon={FiLock} className="mr-1 h-3 w-3" />
            Payments are secure and encrypted
          </div>
        </div>
      </form>
    </div>
  );
};

export default MockStripePayment;